export default __webpack_public_path__ + "static/media/20w50.03cf2793.png";